const API_BASE = (import.meta as any)?.env?.VITE_API_URL || '';

/** Authenticated fetch — always sends session cookie for multi-tenant APIs. */
export async function fetchJSON(path: string, init: RequestInit = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
  return fetch(url, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init.headers || {}) },
    ...init,
  });
}

export const apiFetch = fetchJSON;